export interface ToastAlertConfig {
  type: 'Neutral' | 'Success' | 'Error' | 'Warning' | 'Info';
  title: string;
  description?: string;
  duration: number;
  position: ToastAlertPosition;
}

export type ToastAlertPosition =
  | 'top-left'
  | 'top'
  | 'top-right'
  | 'bottom-left'
  | 'bottom'
  | 'bottom-right';

export type ToastAlertConfigInput = Partial<Omit<ToastAlertConfig, 'title'>> & {
  title: string;
};

export const DEFAULT_TOAST_CONFIG: Omit<ToastAlertConfig, 'title'> = {
  type: 'Neutral',
  description: '',
  duration: 3000,
  position: 'top-right',
};
